import Jt808SetMaxSpeedModal from './jt808-set-max-speed-modal.vue'
export default Jt808SetMaxSpeedModal
